import '@/styles/global.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";

import AboutSection from '@/components/AboutSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import HeroSection from '@/components/HeroSection';
import InvestmentSection from '@/components/InvestmentSection';
import Navbar from '@/components/Navbar';
import PortfolioSection from '@/components/PortfolioSection';
import { ThemeProvider } from '@/contexts/ThemeContext';
import AboutPage from '@/pages/AboutPage';
import ErrorPage from '@/pages/ErrorPage';
import PortfolioPage from '@/pages/PortfolioPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsPage from '@/pages/TermsPage';

function Home() {
  return (
    <div className="font-outfit">
      <ThemeProvider>
        <div className="bg-white text-foreground">
          <Navbar />
          <main>
            <HeroSection />
            <PortfolioSection />
            <InvestmentSection />
            <AboutSection />
            <ContactSection />
          </main>
          <Footer />
        </div>
      </ThemeProvider>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
